import React from 'react';
import PropTypes from 'prop-types';

const Content = ({ children, contentHeight, className }) => (
  <div className={`-wa-modal__content ${className}`} style={{ height: contentHeight }}>
    {children}
  </div>
);

Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

Content.defaultProps = {
  className: ''
};


Content.displayName = 'Content';

export default Content;